'use strict';

// Expose only these two globally for legacy scripts
window._ = require('underscore');
window.Backbone = require('backbone');

// Set up Logging first to get more accurate app perf
import {getLogger, levels} from 'loglevel';
const log = getLogger('performance');
let appPerfStart;
if (log.getLevel() <= levels.DEBUG) appPerfStart = performance.now();
// End logging setup
const Handlebars = require('hbsfy/runtime');

import './index.scss';

import entryPoints from './entryPoints/index';
import {Initialisation} from './utilities/Initialisation';
import uikit from './uikit';
import mediator from './js/mediator';
var config = require('./js/config');

// initialize all feature flags
import * as featureFlags from './utilities/featureFlags';

const initialisation = new Initialisation();
uikit.registerEntryPoints(entryPoints);

uikit.mediator.on(config.events.global.appIsInitialised, () => {
  uikit.initialize();
});

window.Arrow = window.Arrow || {};

window.onYouTubeIframeAPIReady = () => {
  window.youTubeIframeApiReady = true;
  mediator.trigger('youtubeApiIframe:ready');
};

// Start loading the core environment dependencies
initialisation.load();

// TODO: DT - We need to refactor this legacy code into the correct structure
function start() {
  uikit.mediator.set(config.events.global.appIsInitialised, true);

  require('./utilities/globalisation').init();

  require('./js/third-party/jquery.validate.translations');
  require('./js/third-party/String.split');

  if (typeof IS_DEV !== 'undefined') {
    var logger = require('loglevel');
    if (logger.getLevel() > logger.levels.DEBUG) {
      logger.setLevel(logger.levels.DEBUG);
    }
    // THESE FILES WILL BE EXCLUDED IN THE DIST GRUNT TASK
    require('./js/frontend-only/feIndex');
    require('./js/frontend-only/componentsPage');
  }



  // Core setup
  require('./js/breakpoints');
  require('./js/uievents');
  require('./js/handlebars-helpers/clientUtil')(Handlebars);
  require('./js/handlebars-helpers/util')(Handlebars);
  require('./js/handlebars-helpers/comparisons')(Handlebars);
  require('./js/handlebars-helpers/math')(Handlebars);
  require('./js/handlebars-helpers/globalisationHelpers')(Handlebars);
  require('./js/handlebars-helpers/SitecoreHelpers')(Handlebars);

  // Core site functionality
  require('./js/session/index');
  require('./js/components/ErrorModalView');
  require('./js/navigation/navigation');
  require('./js/cookie-bar');

  // Components
  _.defer(function(featureFlags) {
    var components = require('./js/components');
    var $global = require('./js/globalElements');
    components.loadComponents($global.$body);

    require('./js/tabbed-content');
    require('./js/components/ShareModalView');
    require('./js/components/ShareEmailModalView');
    require('./components/SaveTo/SaveToModalView');
    require('./js/components/ArrangePaymentModalView');    
    require('./components/Bloomreach/BloomreachService');
  }, featureFlags);

  // Pages
  _.defer(function() {
    require('./js/manufacturers/manufacturers');
    require('./js/reference/reference');
  });

  uikit.mediator.trigger(config.events.global.appIsInitialised);

  const url = new URL(document.location.href);
  const urlOrigin = url.origin;
  let scriptUrl = '';
  if (urlOrigin.includes('www')) {
    scriptUrl = config.analytics.adobeScriptUrlLive;
  } else if (urlOrigin.includes('qa') || urlOrigin.includes('uat') || urlOrigin.includes('staging')) {
    scriptUrl = config.analytics.adobeScriptUrlQa;
  } else if (urlOrigin.includes('dev') || urlOrigin.includes('local')) {
    scriptUrl = config.analytics.adobeScriptUrlDev;
  }
  injectAdobeAnalyticScript(scriptUrl);

  logAppPerformance();
}

function injectAdobeAnalyticScript(adobeScriptUrl) {
  const script = document.createElement('script');
  script.src = adobeScriptUrl;
  script.async = true;
  // script.onload = () => this.scriptLoaded();
  document.body.appendChild(script);
}

function logAppPerformance() {
  if (appPerfStart) {
    let appPerfNow = performance.now();
    let initSpeed = appPerfNow - appPerfStart;
    log.info(`App Initialize speed: ${initSpeed}ms`);
  }
}

// Register the start function to indicate when all bundles are in the page
// and we can initialise all components and entrypoints
window.Arrow.start = () => {
  if (uikit.mediator.get(config.events.global.appIsInitialising)) {
    start();
  } else {
    uikit.mediator.on(config.events.global.appIsInitialising, () => {
      start();
    });
  }
};



// WEBPACK FOOTER //
// ./assets/index.js